<template>
<div class="tableDetail">
<!--  <div>-->
<!--    <otherNav></otherNav>-->
<!--  </div>-->
  <div class="main-row contain">
    <div v-if="this.formName === 'seeds'" class="col col-xlg-12 col-lg-12 col-sm-12">
     <seeds :info-content="infoContentSeeds" :title="title"></seeds>
    </div>
    <div v-if="this.formName === 'seedNew'" class="col col-xlg-12 col-lg-12 col-sm-12">
      <seeds :info-content="infoContentSeedNew" :title="title"></seeds>
    </div>
    <div v-else-if="this.formName === 'dna'" class="col col-xlg-12 col-lg-12 col-sm-12">
      <dna :info-content="infoContentDna" :title="title"></dna>
    </div>
    <div v-else-if="this.formName === 'dryBlade'" class="col col-xlg-12 col-lg-12 col-sm-12">
      <dried-leaf :info-content="infoContentDriedLeaf" :title="title"></dried-leaf>
    </div>
    <div v-else-if="this.formName === 'animalGermplasmNew'" class="col col-xlg-12 col-lg-12 col-sm-12">
      <germplasm-animal :info-content="infoContentGermplasmAnimal" :title="title"></germplasm-animal>
    </div>
    <div v-else-if="this.formName === 'dnaBarZoo'" class="col col-xlg-12 col-lg-12 col-sm-12">
      <spine-animal :info-content="infoContentSpineAnimal" :title="title"></spine-animal>
    </div>
    <div v-else-if="this.formName === 'dnaBarPlant'" class="col col-xlg-12 col-lg-12 col-sm-12">
      <vascular-plant :info-content="infoContentVascularPlant" :title="title"></vascular-plant>
    </div>
    <div v-else-if="this.formName === 'riskPlantDirectory'" class="col col-xlg-12 col-lg-12 col-sm-12">
      <wild-plant-info :info-content="infoContentWildPlant" :title="title"></wild-plant-info>
    </div>
    <div v-else-if="this.formName === 'specificPlantDirectory'" class="col col-xlg-12 col-lg-12 col-sm-12">
      <endemic-plant-info :info-content="infoContentEndemicPlant" :title="title"></endemic-plant-info>
    </div>
  </div>
</div>
</template>

<script>
import otherNav from '@/components/navBar/otherNav'
import {getSeedsInfo,getDnaInfo, getDriedLeafInfo, getAnimalgermplasm,
  getSpineAnimal, getVascularPlant, getWildPlant, getEndemicPlant} from "@/network/resourceBaseCommon";
import seeds from '@/components/tableDetail/seeds'
import dna from '@/components/tableDetail/dna'
import driedLeaf from "@/components/tableDetail/driedLeaf";
import germplasmAnimal from "@/components/tableDetail/germplasmAnimal";
import spineAnimal from "@/components/tableDetail/spineAnimal";
import vascularPlant from "@/components/tableDetail/vascularPlant";
import wildPlantInfo from '@/components/tableDetail/wildPlantInfo'
import endemicPlantInfo from '@/components/tableDetail/endemicPlantInfo'
export default {
  name: "tableDetail",
  components: {
    otherNav,seeds, dna, driedLeaf, germplasmAnimal, spineAnimal, vascularPlant, wildPlantInfo, endemicPlantInfo
  },
  data() {
    return {
      detailId: 0,
      formName: '',
      title: '',
      infoContentSeeds: {},
      infoContentSeedNew: {},
      infoContentDna: {},
      infoContentDriedLeaf: {},
      infoContentGermplasmAnimal: {},
      infoContentSpineAnimal: {},
      infoContentVascularPlant: {},
      infoContentWildPlant: {},
      infoContentEndemicPlant:{}
    }
  },
  mounted() {
    this.detailId = parseInt(this.$route.query.id)
    this.formName = this.$route.query.formName
    this.title = this.$route.query.name
    this.getDetail()
  },
  methods: {
    handleSelect(key, keyPath) {
      this.$router.push({path:key}).catch(err => {
        // console.log(err)
      })
    },
    getDetail () {
      if(this.formName == 'seeds') {
        getSeedsInfo(this.detailId).then(res => {
          this.infoContentSeeds = res.data.data
        })
      }else if(this.formName == 'seedNew') {
        getSeedsInfo(this.detailId).then(res => {
          // console.log('345',res)
          this.infoContentSeedNew = res.data.data
        })
      } else if(this.formName == 'dna') {
        getDnaInfo(this.detailId).then(res => {
          this.infoContentDna = res.data.data
        })
      } else if(this.formName == 'dryBlade') {
        getDriedLeafInfo(this.detailId).then(res => {
          this.infoContentDriedLeaf = res.data.data
        })
      }else if(this.formName == 'animalGermplasmNew') {
        getAnimalgermplasm(this.detailId).then(res => {

          this.infoContentGermplasmAnimal = res.data.data
        })
      }else if(this.formName == 'dnaBarZoo') {
        getSpineAnimal(this.detailId).then(res => {
          this.infoContentSpineAnimal = res.data.data
        })
      }else if(this.formName == 'dnaBarPlant') {
        getVascularPlant(this.detailId).then(res => {

          this.infoContentVascularPlant = res.data.data
        })
      }else if(this.formName == 'riskPlantDirectory') {
        getWildPlant(this.detailId).then(res => {
          // console.log(res)
          this.infoContentWildPlant = res.data.data
        })
      }else if(this.formName == 'specificPlantDirectory') {
        getEndemicPlant(this.detailId).then(res => {
          // console.log(res)
          this.infoContentEndemicPlant = res.data.data
        })
      }



    },
  }
}
</script>

<style scoped lang="scss">
.contain {
  padding: 20px 50px;
}

@media screen and (max-width: 1200px){
  .contain {
    padding: 20px 50px;
  }
}
@media screen and (max-width: 992px){}
@media screen and (max-width: 768px){}
@media screen and (max-width: 576px){
  .contain {
    padding: 10px 10px;
  }
}
.tableDetail{
  min-height: 500px;
  .main-row {
    .col {
      padding: 5px 5px ;
    }
    .img {
      img{
        width: 100%;
        height: 100%;
      }
    }
  }

}

</style>